/* Airy opens the respond.io widget. That script loads async, so a click
   before it is ready would silently do nothing: poll briefly, then fall
   back to WhatsApp rather than dead-end the customer. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cro-airy]');
    if (!btn) return;
    e.preventDefault();
    var n = 0;
    (function open() {
      var r = window.$respond;
      if (r && typeof r.do === 'function') { r.do('chat:open'); return; }
      if (r && typeof r.open === 'function') { r.open(); return; }
      if (++n > 20) { window.open('https://wa.me/97142860960', '_blank', 'noopener'); return; }
      setTimeout(open, 150);
    })();
  }, true);
})();
